import { render } from "./App.vue?vue&type=template&id=0bdc81f4&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0bdc81f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bdc81f4"

export default script